import {createFeatureSelector, createSelector} from "@ngrx/store";
import {tradeRoutesFeatureKey} from "./trade-routes.reducer";
import {TradeRoute} from "../../models/TradeRoute";

export const tradeRoutesSelector = createFeatureSelector<TradeRoute[]>(tradeRoutesFeatureKey);
